import { Badge } from "@/components/ui/badge";

const MAP = {
  bureau_admin: { label: "Bureau Admin", cls: "bg-indigo-100 text-indigo-800 border-indigo-200 dark:bg-indigo-950/70 dark:text-indigo-300 dark:border-indigo-800" },
  hr_manager: { label: "HR Manager", cls: "bg-emerald-100 text-emerald-800 border-emerald-200 dark:bg-emerald-950/70 dark:text-emerald-300 dark:border-emerald-800" },
  processor: { label: "Payroll Processor", cls: "bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-950/70 dark:text-amber-300 dark:border-amber-800" },
  employee: { label: "Employee", cls: "bg-blue-100 text-blue-800 border-blue-200 dark:bg-blue-950/70 dark:text-blue-300 dark:border-blue-800" },
};

export function RoleBadge({ role }) {
  const m = MAP[role] || MAP.employee;
  return (
    <Badge data-testid="role-badge" variant="outline" className={`font-medium ${m.cls}`}>
      {m.label}
    </Badge>
  );
}

const STATUS = {
  completed: "bg-emerald-100 text-emerald-700 border-emerald-200 dark:bg-emerald-950/60 dark:text-emerald-300",
  pending_approval: "bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-950/60 dark:text-amber-300",
  active: "bg-emerald-100 text-emerald-700 border-emerald-200 dark:bg-emerald-950/60 dark:text-emerald-300",
  approved: "bg-emerald-100 text-emerald-700 border-emerald-200 dark:bg-emerald-950/60 dark:text-emerald-300",
  pending: "bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-950/60 dark:text-amber-300",
  processing: "bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-950/60 dark:text-amber-300",
  open: "bg-blue-100 text-blue-700 border-blue-200 dark:bg-blue-950/60 dark:text-blue-300",
  draft: "bg-slate-100 text-slate-600 border-slate-200 dark:bg-slate-800 dark:text-slate-300",
  rejected: "bg-rose-100 text-rose-700 border-rose-200 dark:bg-rose-950/60 dark:text-rose-300",
  inactive: "bg-slate-100 text-slate-600 border-slate-200 dark:bg-slate-800 dark:text-slate-300",
};

export function StatusBadge({ status }) {
  const cls = STATUS[status] || STATUS.draft;
  return (
    <Badge variant="outline" className={`capitalize font-medium ${cls}`}>
      {status}
    </Badge>
  );
}
